import { translate } from 'i18n/i18n'
import { captureFrontendError } from 'utils/captureFrontendError'
import type { TActiveGateway, TActiveNode, TNodeType, TPlannedGateway, TPlannedNode } from '../types'

export const getNodeTypeLabelFromNode = (
  node: TActiveNode | TPlannedNode | TActiveGateway | TPlannedGateway,
): string => {
  // if node is a gateway, return the gateway type
  if ('gatewayType' in node) {
    return getNodeTypeLabel(node.gatewayType)
  }

  return getNodeTypeLabel(node.nodeType)
}

export const getNodeTypeLabel = (nodeType: TNodeType): string => {
  // Defensive: no reported event has hit this, but .toLowerCase() below would
  // throw on a null/undefined nodeType rather than falling through to the
  // default branch, so the failure would be a crash instead of a report.
  if (!nodeType) {
    captureFrontendError(new Error(`Node type is missing: "${nodeType}"`))

    // Every caller renders this straight into the UI, so an empty string would
    // leave a blank label with no hint anything went wrong.
    return translate.phrases.placeholder('Unknown')
  }

  switch (nodeType.toLowerCase()) {
    case 'scd':
      return translate.phrases.placeholder('SN Dispenser')

    case 'ln_scd':
      return translate.phrases.placeholder('LN Dispenser')

    case 'nn_scd':
      return translate.phrases.placeholder('Unconnected Dispenser')

    case 'gtwy':
      return translate.phrases.placeholder('SN Gateway')

    case 'ln_gtwy':
      return translate.phrases.placeholder('LN Gateway')

    case 'rpt':
      return translate.phrases.placeholder('Repeater')

    case 'trp':
      return translate.phrases.placeholder('SN Trap')

    case 'dn_trp':
      return translate.phrases.placeholder('DN Trap')

    case 'y':
      return translate.phrases.placeholder('SN Station')

    case 'dn_y':
      return translate.phrases.placeholder('DN Station')

    case 'ln_r':
      return translate.phrases.placeholder('LN Station')

    default: {
      captureFrontendError(new Error(`Node type: "${nodeType}" has not been implemented`))

      return nodeType
    }
  }
}
